"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SensitiveTopicTargetsResponseToJSON = exports.SensitiveTopicTargetsResponseFromJSONTyped = exports.SensitiveTopicTargetsResponseFromJSON = exports.instanceOfSensitiveTopicTargetsResponse = void 0;
var runtime_1 = require("../runtime");
var TargetBase_1 = require("./TargetBase");
/**
 * Check if a given object implements the SensitiveTopicTargetsResponse interface.
 */
function instanceOfSensitiveTopicTargetsResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfSensitiveTopicTargetsResponse = instanceOfSensitiveTopicTargetsResponse;
function SensitiveTopicTargetsResponseFromJSON(json) {
    return SensitiveTopicTargetsResponseFromJSONTyped(json, false);
}
exports.SensitiveTopicTargetsResponseFromJSON = SensitiveTopicTargetsResponseFromJSON;
function SensitiveTopicTargetsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'sensitiveTopics': !(0, runtime_1.exists)(json, 'sensitive_topics') ? undefined : (json['sensitive_topics'].map(TargetBase_1.TargetBaseFromJSON)),
    };
}
exports.SensitiveTopicTargetsResponseFromJSONTyped = SensitiveTopicTargetsResponseFromJSONTyped;
function SensitiveTopicTargetsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'sensitive_topics': value.sensitiveTopics === undefined ? undefined : (value.sensitiveTopics.map(TargetBase_1.TargetBaseToJSON)),
    };
}
exports.SensitiveTopicTargetsResponseToJSON = SensitiveTopicTargetsResponseToJSON;
